import { TopicTypes } from '@/utils/constants'
import { Box, capitalize, Typography } from '@mui/material'
import { useMemo } from 'react'

interface Props {
  type: string
  border?: string
  textColor?: string
  fillColor?: string
}

export function TagTopic({
  type,
  border = '1px solid rgba(255, 255, 255, 0.2)',
  textColor = '#525E9C',
  fillColor = 'transparent',
}: Props) {
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      p={'8px 16px'}
      border={border}
      borderRadius={'10px'}
      bgcolor={fillColor}
      sx={{
        height: '36px',
        backdropFilter: 'blur(10px)',
        backgroundColor: fillColor === 'transparent' ? 'rgba(255, 255, 255, 0.08)' : fillColor,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          backgroundColor: fillColor === 'transparent' ? 'rgba(255, 255, 255, 0.12)' : fillColor,
          borderColor: 'rgba(255, 255, 255, 0.3)',
        },
      }}
    >
      <Typography
        fontSize={'13px'}
        fontFamily={'Inter'}
        fontWeight={600}
        lineHeight={'16px'}
        sx={{
          color: textColor,
          letterSpacing: '-0.01em',
        }}
      >
        {capitalize(type)}
      </Typography>
    </Box>
  )
}
